import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import {
  Container,
  Button,
  Modal,
  ModalBody,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"
import Header1 from "./header"
import "./../styles/report.css"
import "./../styles/highcharts.css"
import Header from "../components/layout/Header"
import { window as Monad } from "browser-monads"
import Source from "../images/Db.svg"

import React, { useState, useRef, useEffect } from "react"
import {
  Link,
  Element,
  Events,
  animateScroll as scroll,
  scrollSpy,
  scroller,
} from "react-scroll"
import classnames from "classnames"
import { navigate as Reportnav, Link as Gatsbylink } from "gatsby"
import SideMenu from "./ReportSideMenu"

import Overview from "./../images/headers/overviewIcon.svg"
import Country from "./../images/headers/countryIcon.svg"
import Reeg from "./../images/headers/reeg.svg"
import Predictor from "./../images/headers/predictorIcon.svg"
import Int from "./../images/headers/interactionIcon.svg"

import { auth, signInWithGoogle } from "../utils/firebase"
import { useAuthState } from "react-firebase-hooks/auth"
import useAuthUser from "../hooks/useAuthUser"

import { FaGoogle } from "react-icons/fa"
import User from "./reports/User"

if (typeof window !== "undefined") {
  // eslint-disable-next-line global-require
  require("smooth-scroll")('a[href*="#"]')
}
const Reportlayout = ({
  children,
  fluid,
  shortname,
  cat,
  menudata,
  variable,
}) => {
  // global variable used in window.onscroll function
  const [showTitle, setShowTitle] = useState(false)
  const [showSectionNav, setShowSectionNav] = useState(false)
  const [showMenu, setShowMenu] = useState(true)
  const [loginPopupVisible, setLoginPopupVisible] = useState(false)
  const [userProfilOpen, setUserProfilOpen] = useState(false)

  const navBar = useRef()
  const writing = useRef()
  const [user, loading, error] = useAuthState(auth)
  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (document.documentElement.scrollTop < 50) {
        setShowTitle(false)
        setShowSectionNav(false)
      } else if (
        document.documentElement.scrollTop > 50 &&
        document.documentElement.scrollTop < 100
      ) {
        setShowTitle(true)
        setShowSectionNav(false)
      } else if (document.documentElement.scrollTop > 600) {
        setShowTitle(true)
        setShowSectionNav(true)
      } else if (document.documentElement.scrollTop < 600) {
        // setShowSectionNav(false);
      }
    })
  }, [])

  // Sidebar
  useEffect(() => {
    setTimeout(() => {
      if (Monad.innerWidth < 380) {
        setShowMenu(false)
      }
    }, 1000)
  }, [])

  function openSlideMenu() {
    setShowMenu(true)
  }

  function closeSlideMenu() {
    setShowMenu(false)
  }
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
      <nav
        ref={navBar}
        id="someID"
        style={{ background: "null !important" }}
        className={classnames("navbar_report", {
          "with-title": showTitle,
          navmini: showMenu,
        })}
      >
        <span
          style={{ marginLeft: "40%" }}
          className={classnames("navbar_report", {
            "with-title": showTitle,
            navmini: showMenu,
          })}
        >
          <p
            id="navsource"
            className="pid"
            style={{
              marginRight: "5px",
              color: "#919191",
            }}
          >
            {" "}
            {cat}{" "}
          </p>
          {"  "}
          <p
            id="navsource"
            className="pid"
            style={{
              color: "#ffffff",
            }}
          >
            {shortname}{" "}
          </p>
        </span>{" "}
        <div style={{ marginRight: "10px" }} onClick={openSlideMenu}>
          <i className={classnames("fas fa-bars", { "d-none": showMenu })} />
        </div>
        <div
          className={classnames("sideMenu-bg", {
            show: showMenu,
          })}
        ></div>{" "}
        <div
          style={{
            cursor: "auto",
          }}
          className={classnames("sideMenu", {
            show: showMenu,
          })}
        >
          <div
            className="d-flex"
            style={{
              marginBottom: "6px",
              cursor: "pointer",
              display: "inline-flex",
            }}
          >
            <div
              className="mr-auto p-2"
              style={{
                marginTop: 0,
                color: "rgb(205, 205, 205)",
                marginLeft: 0,
                marginBottom: "19px",
              }}
            >
              {" "}
              <Gatsbylink
                to="/"
                style={{
                  color: "rgb(255, 255, 255)",
                  border: "1px solid rgb(92, 92, 92)",
                  padding: "5px",
                  fontSize: "10px",
                }}
              >
                On
              </Gatsbylink>
            </div>{" "}
            <div style={{ marginTop: "18px" }}>
              <User />

              <div style={{ textAlign: "center" }}>
                <Gatsbylink
                  to="/source/ess"
                  style={{
                    fontSize: "14px",
                    marginTop: "17px",
                    color: "rgb(4, 249, 85)",
                    fontFamily: "Arial",
                    fontSize: "12px",
                    marginTop: "17px",
                  }}
                >
                  <button
                    className="reptag sourcereptag"
                    style={{ fontSize: "9px" }}
                  >
                    <Source
                      fill="#fff"
                      style={{
                        height: "10px",
                        width: "10px",
                        marginRight: "5px",
                        marginLeft: "5px",
                      }}
                    />
                    European Social Survey
                  </button>
                </Gatsbylink>
              </div>
            </div>
            <div
              className="mr-auto p-2"
              style={{
                border: "0 solid #5c5c5c",
                padding: "5px",
                marginTop: "5px",

                color: " #cdcdcd",
              }}
            >
              {" "}
            </div>
            <i className="fas fa-times p-2" onClick={closeSlideMenu}></i>
          </div>{" "}
          <SideMenu
            activeItem={variable}
            items={menudata}
            reverse={false}
            onMenuItemClick={value => Reportnav(`/reports/ess/${value}`)}
          />
        </div>
        <span ref={writing}>
          <span
            className={classnames("topnav", {
              navmini: showMenu,
            })}
          >
            {shortname}
          </span>
        </span>
      </nav>
      <nav
        className={classnames("navbar1", {
          show: showSectionNav,
          navmini: showMenu,
        })}
      >
        <ul>
          <li className="header">
            <Link
              activeClass="active"
              to="overview"
              spy={true}
              offset={-200}
              smooth={true}
              duration={500}
            >
              <span>
                {" "}
                <Overview
                  fill="#e1e1e1"
                  style={{
                    verticalAlign: "middle",
                    borderStyle: "none",

                    margin: "0 10px 0 4px",
                    height: "20px",
                    width: "20px",
                  }}
                />{" "}
                <p className="header">Overview</p>
              </span>
            </Link>
          </li>
          <li className="header">
            <Link
              activeClass="active"
              to="country"
              spy={true}
              offset={-200}
              smooth={true}
              duration={500}
            >
              {" "}
              <span>
                {" "}
                <Country
                  fill="#e1e1e1"
                  style={{
                    verticalAlign: "middle",
                    borderStyle: "none",

                    margin: "0 10px 0 4px",
                    height: "20px",
                    width: "20px",
                  }}
                />{" "}
                <p className="header">Country</p>
              </span>
            </Link>
          </li>
          <li className="header">
            <Link
              activeClass="active"
              to="regression"
              spy={true}
              offset={-200}
              smooth={true}
              duration={500}
            >
              <span>
                {" "}
                <Reeg
                  fill="#e1e1e1"
                  style={{
                    verticalAlign: "middle",
                    borderStyle: "none",

                    margin: "0 10px 0 4px",
                    height: "20px",
                    width: "20px",
                  }}
                />{" "}
                <p className="header">Regression</p>
              </span>
            </Link>
          </li>
          <li className="header">
            <Link
              activeClass="active"
              to="interaction"
              spy={true}
              offset={-200}
              smooth={true}
              duration={500}
            >
              <span>
                {" "}
                <Int
                  fill="#e1e1e1"
                  style={{
                    verticalAlign: "middle",
                    borderStyle: "none",

                    margin: "0 10px 0 4px",
                    height: "20px",
                    width: "20px",
                  }}
                />{" "}
                <p className="header">Interaction</p>
              </span>
            </Link>
          </li>{" "}
          <li className="header">
            <Link
              activeClass="active"
              to="predictor"
              spy={true}
              offset={-200}
              smooth={true}
              duration={500}
            >
              <span>
                {" "}
                <Predictor
                  fill="#e1e1e1"
                  style={{
                    verticalAlign: "middle",
                    borderStyle: "none",

                    margin: "0 10px 0 4px",
                    height: "20px",
                    width: "20px",
                  }}
                />{" "}
                <p className="header">Key Predictors</p>
              </span>
            </Link>
          </li>
        </ul>
      </nav>{" "}
      <div
        className={classnames("maxi", {
          mini: showMenu,
        })}
      >
        <Container fluid={fluid} className="bodyreport">
          <main>{children}</main>
        </Container>
      </div>
    </>
  )
}

Reportlayout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Reportlayout
